import illustration_1 from "../../../Assets/ServicesPage_Assets/Icon_illustrator_1.png";
import illustration_2 from "../../../Assets/ServicesPage_Assets/Icon_illustrator_2.png";
import illustration_3 from "../../../Assets/ServicesPage_Assets/Icon_illustrator_3.png";
import illustration_4 from "../../../Assets/ServicesPage_Assets/Icon_illustrator_4.png";

export const offeredService = [
  {
    img: illustration_1,
    title: "Have doubts?",
    para: "Fear not, peer to peer group will help you out any issue, big or small.",
  },
  {
    img: illustration_2,
    title: "Get Certificate!",
    para: "Receive a linkedIn shareable certificate after the completion of live classes",
  },
  {
    img: illustration_3,
    title: "All Live classes",
    para: "Watch all the classes live and clear your doubts instantly.",
  },
  {
    img: illustration_4,
    title: "Project-based Learning",
    para: "An immersive project-based curriculum focused on practical developer skills.",
  },
];
export const faqs = [
  {
    ques: "What is this program",
    ans: "The program is a live bootcamp where you can attend all sessions in real-time. Support is available for any queries. The bootcamp offers an immersive learning experience to acquire knowledge and skills for web development.",
  },
  {
    ques: "I did not receive the confirmation mail or any email from JuriLearn, what do i do?",
    ans: "Well, in most cases it should not happen. Make sure you give us 5-10 minutes in case you don't receive any emails right away. Even then if you don't receive anything from us, then please write to Juridentyi@gmail.com and our awesome support team will clarify your problems in 24-48 hours",
  },
  {
    ques: "I don't know a lot about web dev , should i take this program?",
    ans: "Definitely. You should take the program as it will help you kickstart your journey as a web developer and also pick you up from the bed and make you stop procrastinating on the idea of becoming a web developer.",
  },
  {
    ques: "I am not from Computer Science Background , will this program help me?",
    ans: "The goal of this program is to help you start your journey no matter what your situation is. It doesn't matter if you are from comouter science background or not, you'll be able to do it",
  },
  {
    ques: "How will i access the content?",
    ans: "After you purchase the program, you'll receive an email with all the details.",
  },
];
